export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        const modelInputs = ele.querySelectorAll('[data-model-input]');
        const startInputEle = modelInputs[0];
        const endInputEle = modelInputs[1];
        const visualInputs = ele.querySelectorAll('[data-visual-input]');
        const startInputVisualEle = visualInputs[0];
        const endInputVisualEle = visualInputs[1];
        const errorEle = ele.querySelector('[data-help]');
        const stopChangePropagation = ele.hasAttribute(
            'data-stop-change-propagation'
        );

        startInputVisualEle.addEventListener('input', handleInput);
        endInputVisualEle.addEventListener('input', handleInput);
        startInputVisualEle.addEventListener('keypress', handleKeypress);
        endInputVisualEle.addEventListener('keypress', handleKeypress);
        startInputVisualEle.addEventListener('keydown', handleKeydown);
        endInputVisualEle.addEventListener('keydown', handleKeydown);
        startInputVisualEle.addEventListener('change', handleChange);
        endInputVisualEle.addEventListener('change', handleChange);
        startInputVisualEle.addEventListener('blur', handleBlur);
        endInputVisualEle.addEventListener('blur', handleBlur);
        ele.closest('form').addEventListener('submit', validate);
        ele.closest('form').addEventListener('change', validate);
        ele.closest('form').addEventListener('submit', trackClick);
        ele.closest('form').addEventListener('change', trackClick);

        let startInputPreviousValue = startInputEle.value;
        let endInputPreviousValue = endInputEle.value;

        function trackClick() {
            trackIfChanged(startInputPreviousValue, startInputEle);
            startInputPreviousValue = startInputEle.value;

            trackIfChanged(endInputPreviousValue, endInputEle);
            endInputPreviousValue = endInputEle.value;

            function trackIfChanged(previousValue, inputEle) {
                if (inputEle.value !== previousValue) {
                    trackingservice.trackEventObject({
                        analyticsName: `navigation.filter-by-${inputEle.name.replace(
                            /_/g,
                            ''
                        )}.click`,
                        numberValue: inputEle.value,
                    });
                }
            }
        }

        function handleChange(event) {
            if (stopChangePropagation) {
                event.stopPropagation();
            }
            validate();
        }

        function handleBlur(event) {
            if (!stopChangePropagation) {
                // In WebKit, when setting `value` programmatically, change events in are sometimes
                // not dispatched. Send a, quite possibly duplicate, change event manually instead.
                // Unable to find a WebKit bug, but here is an old one for Chromium pre-Blink.
                // https://bugs.chromium.org/p/chromium/issues/detail?id=92492,
                event.target.dispatchEvent(
                    new Event('change', { bubbles: true })
                );
            }
        }

        function handleInput(event) {
            if (ele.hasAttribute('data-format-number')) {
                formatNumber(event.target);
            }

            hideError();
            setModelValue();
        }

        function handleKeydown(event) {
            if (
                ele.hasAttribute('data-format-number') &&
                event.which === 8 /* Backspace */
            ) {
                handleBackspace(event.target);
            }

            event.stopPropagation(); // Swallow this to avoid focus styling being applied
        }

        function handleKeypress(event) {
            // Firefox receives keypress for non-printable chars, but they have charCode 0
            // 0-31 is unprintable
            if (
                event.ctrlKey ||
                event.metaKey ||
                event.charCode === 0 ||
                event.which < 32
            ) {
                return;
            }

            // Only allow 0-9
            if (event.which < 48 || event.which > 57) {
                event.preventDefault();
            }
        }

        function setModelValue() {
            const startValue = startInputVisualEle.value.replace(/ /g, '');
            const endValue = endInputVisualEle.value.replace(/ /g, '');

            startInputEle.value = isNaN(startValue) ? '' : startValue;
            endInputEle.value = isNaN(endValue) ? '' : endValue;
        }

        function validate() {
            if (
                startInputEle.value &&
                endInputEle.value &&
                Number(startInputEle.value) > Number(endInputEle.value)
            ) {
                showError('Fra-verdien må være lavere enn Til-verdien');
            }
        }

        // Thousand separator: 1000 -> "1 000"
        function format(number) {
            // http://stackoverflow.com/a/2901298
            return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }

        function setCursorPosition(target, pos) {
            // hzr: There seems to be a bug in IE 10 where setting this when the value is blank.
            // Haven't investigated, but this avoids it.
            if (target.value) {
                target.selectionStart = target.selectionEnd = pos;
            }
        }

        function handleBackspace(target) {
            const value = target.value;
            const selectionStart = target.selectionStart;
            const selectionEnd = target.selectionEnd;
            // If the cursor is just after a space, or a space is selected, we need to reposition
            // the cursor just before the space for the backspace to have effect.
            // `|` in the examples beneath represent the cursor position. If there are two
            // `|` it represents a selection.
            // The second state represents the cursor position after the number has been
            // formatted.

            if (
                value[selectionStart - 1] === ' ' &&
                selectionStart === selectionEnd
            ) {
                // If the cursor is just before a space when pressing Backspace
                // "500 |000" -> "50| 000"
                setCursorPosition(target, selectionStart - 1);
            } else if (value.slice(selectionStart, selectionEnd) === ' ') {
                // If exactly one space is selected, we remove the digit just before it when pressing
                // Backspace. An alternative would be to reposition the cursor just before the space
                // and not delete anything, but that requires a bit more work.
                // "500| |000" -> "50| 000"
                setCursorPosition(target, selectionStart);
            }
        }

        function formatNumber(target) {
            // Nothing after the cursor gets formatted, so check the length of the string
            // after the cursor and set it back at that position after we have set the
            // formatted value
            const cursorPos = target.value.slice(target.selectionEnd).length;
            const formattedValue = format(target.value.replace(/ /g, ''));
            target.value = formattedValue;
            setCursorPosition(target, formattedValue.length - cursorPos);
        }

        function showError(text) {
            ele.classList.add('invalid');
            startInputVisualEle.setAttribute('aria-invalid', 'true');
            endInputVisualEle.setAttribute('aria-invalid', 'true');
            startInputVisualEle.setAttribute('aria-describedby', errorEle.id);
            endInputVisualEle.setAttribute('aria-describedby', errorEle.id);
            errorEle.textContent = text;
        }

        function hideError() {
            ele.classList.remove('invalid');
            startInputVisualEle.removeAttribute('aria-invalid');
            endInputVisualEle.removeAttribute('aria-invalid');
            startInputVisualEle.removeAttribute('aria-describedby');
            endInputVisualEle.removeAttribute('aria-describedby');
            errorEle.textContent = '';
        }

        // IE (but not Edge) focuses the first submit button in the form when submitting
        // the form. Set back the focus to the input field here.
        // `document.all` is truthy in IE.
        if (document.all) {
            const setFocusBackOnSubmit = function(event) {
                if (event.which === 13 /* Enter */) {
                    // Queue this to run after the button is focused
                    window.setTimeout(() => {
                        event.target.focus();
                    });
                }
            };
            startInputVisualEle.addEventListener(
                'keypress',
                setFocusBackOnSubmit
            );
            endInputVisualEle.addEventListener(
                'keypress',
                setFocusBackOnSubmit
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/rangeInput.js